import { localized } from "@msuite/utils/locales";
import type { FillPattern } from "@msuite/utils/schemas";
import type { ToolName } from "@msuite/utils/types";

export const TOOL: Record<Uppercase<ToolName>, ToolName> = {
	SELECT: "select",
	POLYGON: "polygon",
	DIMENSION: "dimension",
	TEXT: "text",
} as const;

export const PATTERN_LABEL: Record<FillPattern, string> = {
	solid: localized("image_annotator.patterns.solid"),
	hatch: localized("image_annotator.patterns.hatch"),
	crosshatch: localized("image_annotator.patterns.crosshatch"),
	dots: localized("image_annotator.patterns.dots"),
	checker: localized("image_annotator.patterns.checker"),
	waves: localized("image_annotator.patterns.waves"),
	stripes: localized("image_annotator.patterns.stripes"),
	grid: localized("image_annotator.patterns.grid"),
	plus: localized("image_annotator.patterns.plus"),
	none: localized("image_annotator.patterns.none"),
};

export const TOOLS: Array<ToolName> = [TOOL.SELECT, TOOL.POLYGON, TOOL.DIMENSION, TOOL.TEXT];

export const TOOL_LABEL: Record<ToolName, string> = {
	dimension: localized("image_annotator.tools.dimension"),
	polygon: localized("image_annotator.tools.polygon"),
	select: localized("image_annotator.tools.select"),
	text: localized("image_annotator.tools.text"),
};
